export const pluginID = 'taxProducts';
